import React from 'react';

import { ArrowLeftIcon } from 'components/Icons';

import NavigationButton, { NavigationButtonProps } from './NavigationButton';

import { ButtonVariant } from './Button';

import styles from './Button.module.scss';

const BackButton = ({ link, children, ...restProps }: React.PropsWithChildren<NavigationButtonProps>) => {
  return (
    <NavigationButton {...restProps} variant={ButtonVariant.Alternative} link={link} className={styles.button_back}>
      <ArrowLeftIcon className={styles.arrow_left} width={16} height={12} />
      {children}
    </NavigationButton>
  );
};

export default BackButton;
